import { render, staticRenderFns } from "./CRUDTableDetails.vue?vue&type=template&id=105febd8"
import script from "./CRUDTableDetails.vue?vue&type=script&lang=js"
export * from "./CRUDTableDetails.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableDetails.vue?vue&type=style&index=0&id=105febd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports